export const controller = new AbortController()

// enum Methods { 'GET','POST','PATCH','PUT','DELETE' }

type Response = { status: number, message: string, error: string, data: {}, result: number }

type Props = (
    url:string,
    method?: 'GET'|'POST'|'PATCH'|'PUT'|'DELETE',
    body?:{},
    addKey?: boolean
) => Promise<Response>

const { REACT_APP_API_KEY } = process.env

export const Fetcher:Props = async (url, method = 'GET', body, addKey = false ) => {

  const { signal } = controller
    
  const headers:any = {
    "Accept": "application/json",
    "Content-Type": "application/json"
  }

  /** add currency conversion apiKEy */
  if(addKey)
  headers["apikey"]= REACT_APP_API_KEY;

  const options: any = {
      headers,
      method,
      signal,
  }

  if(method !== 'GET')
  options.body = JSON.stringify(body);

  const request = await fetch(
    url, 
    options
  );
  const response:Response = await request.json()
  let message;
  /**
   * if a response got an error 
   * it will be thrown by the below if conditions
   */
  if(response.status !== 200 && response.status !== 201 && response.status !== undefined){
    if(response.error.length > response.message.length){
      message = response.error
    }else{
      message = response.message
    }
    //
    throw new Error( message )
  }

  return response;
};
